import { dateUtil } from "src/app/support/date-util";
import { Prescription } from "src/app/backend/models/prescription/prescription";

export function getPrescriptionFileName(prescription: Prescription): string {
  return `Ricetta ${prescription.number} ${dateUtil(
    prescription.emittedAt
  ).format("DD_MM_YYYY")}.pdf`;
}

export function getFileNameWithoutExtension(fullFileName: string): string {
  return fullFileName.split(".").slice(0, -1).join(".");
}

export function getFileNamePdf(fileName: string): string {
  return `${fileName}.pdf`;
}
